export default __webpack_public_path__ + "assets/ico_shop-6bc014b3.svg";